// src/pages/BundeslandBerlin.jsx
import React from "react";
import BundeslandPage from "./BundeslandPage";
import { berlin } from "../components/states/berlin";

export default function BundeslandBerlin() {
  return <BundeslandPage data={berlin} />;
}

